import { render, staticRenderFns } from "./chanpinjieshao.vue?vue&type=template&id=8dd81e00&scoped=true&"
import script from "./chanpinjieshao.vue?vue&type=script&lang=js&"
export * from "./chanpinjieshao.vue?vue&type=script&lang=js&"
import style0 from "./chanpinjieshao.vue?vue&type=style&index=0&id=8dd81e00&lang=less&scoped=true&"
import style1 from "./chanpinjieshao.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd81e00",
  null
  
)

export default component.exports